import { FC } from 'react';
import { Label, Toggle } from '@silverfort/sf-components';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { AccountMatchingSettingsForm } from '../types';

const TokenSharingSection: FC = () => {
    const { control } = useFormContext<AccountMatchingSettingsForm>();
    const isAccountMatchingEnabled = useWatch({ control, name: 'isAccountMatchingEnabled' });

    return (
        <div className="rounded-[8px] border border-sf-gray-100 p-6 gap-6">
            <div className="flex">
                <Label
                    className={`min-h-10 w-[235px] ${!isAccountMatchingEnabled ? 'text-sf-gray-300' : ''}`}
                    text="Token sharing"
                />
                <Controller
                    control={control}
                    name="isTokenSharingEnabled"
                    render={({ field: { value, onChange } }) => (
                        <Toggle
                            // todo: remove the "mb-0" after https://silverfort.atlassian.net/browse/AF-36781
                            className="mb-0"
                            disabled={!isAccountMatchingEnabled}
                            checked={isAccountMatchingEnabled ? value : false}
                            label="Enable token sharing"
                            onChange={onChange}
                        />
                    )}
                />
            </div>
        </div>
    );
};

export default TokenSharingSection;
